import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {AlertService, OperatorService, UserService} from "../services";
import {Subject} from "rxjs";
import {ProductService} from "../services/product.service";
import {ResourceService} from "../services/resource.service";

import { locale as polish } from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {SupplierService} from "../services/supplier.service";

@Component({
    templateUrl: './supplier.component.html',
    styleUrls: ['./supplier.component.scss']
})
export class SupplierComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private alertService: AlertService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private supplierService: SupplierService,
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish);
        componentTitleService.clearTitle();
        componentTitleService.addPart('Suppliers');
    }

    ngOnInit() {
        this.supplierService.getAll().subscribe((res: any[])=>{
            this.rows = res;
            this.loadingIndicator = false;
        }, error => {
            this.alertService.error(error);
        })
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
